import { SHAPE_STROKE_PROPS } from './stroke-props';

interface StarProps {
  strokeDasharray: string | undefined;
}

export default function Star({ strokeDasharray }: StarProps) {
  // 5-point star using inner radius 38, outer radius 50, centered at 50,50
  return (
    <polygon
      points="50,0 61,35 98,35 68,57 79,91 50,70 21,91 32,57 2,35 39,35"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
